import Image from 'next/image'

import { Text } from '@wartek-id/text-v1'

import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'

const CardSekolahBinaanEmpty = () => {
  return (
    <SimpleCard className="flex flex-1 p-4 pb-6 gap-9 h-fit grow">
      <div className="flex-none">
        <Image
          src="/images/errors/img-no-access.png"
          alt=""
          width={64}
          height={64}
        />
      </div>

      <div className="flex flex-col gap-2">
        <Text variant="heading-md">
          Pengelolaan Kinerja hanya dapat dilakukan oleh Penilik yang memiliki
          satuan pendidikan binaan
        </Text>
        <Text>
          Mohon periksa kembali data satuan pendidikan binaan Anda di SIMTENDIK.
        </Text>

        {/** TODO: set later */}
        <a href={'#'} target="_blank" rel="noreferrer">
          <Text variant="body-sm-bold" color="informational">
            Ke Pusat Informasi
          </Text>
        </a>
      </div>
    </SimpleCard>
  )
}

export default CardSekolahBinaanEmpty
